var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filtered-tab" },
    [
      _c(
        "div",
        { staticClass: "filtered-tab__tabs container" },
        [
          _c("tab-filter", {
            attrs: {
              tabs: _vm.regions,
              dictionary: Object.assign({}, _vm.dictionary, { all: "All" }),
              "update-query": false,
              "use-all": false,
              query: "region",
              "queryable-data": "region",
            },
            on: {
              "update:final-query": function ($event) {
                _vm.tabQuery = $event
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (ref) {
                    var active = ref.active
                    var click = ref.click
                    var tabs = ref.tabs
                    var move = ref.move
                    return [
                      _vm._t("tab-item", null, {
                        active: active,
                        click: click,
                        tabs: tabs,
                        move: move,
                      }),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("default", null, {
        items: _vm.selectedItems,
        dictionary: _vm.dictionary,
        ckey: _vm.carouselKey,
        active: _vm.currentActive,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }